export enum ECanProduct {
  UNKNOWN,
  PCAN,
  KVASER,
  SLCAN,
}

export const canProductDropdown = [
  ECanProduct[ECanProduct.UNKNOWN],
  ECanProduct[ECanProduct.PCAN],
  ECanProduct[ECanProduct.KVASER],
  ECanProduct[ECanProduct.SLCAN],
];
